module.exports = __webpack_public_path__ + "src/assets/img/cpzx_icon1@2x.69db0f8e.png";